export default __webpack_public_path__ + "static/media/GHSI Regular Board Minutes 21 July 2022.e504c8bd.pdf";